import { DomainAvailabilityReason } from '@tiendanube/common/src/domains/nuvem-domains/types';
import { DomainNotAvailableCard } from './DomainNotAvailableCard';
import { DomainNotAvailableTldCard } from './DomainNotAvailableTldCard';

interface DomainUnavailableCardProps {
  reason: string;
  domain: string;
}

export function DomainUnavailableCard({
  reason,
  domain,
}: Readonly<DomainUnavailableCardProps>) {
  switch (reason) {
    case DomainAvailabilityReason.DomainUnavailable:
      return <DomainNotAvailableCard />;
    case DomainAvailabilityReason.TldNotAllowed:
      return <DomainNotAvailableTldCard domain={domain} />;
    default:
      return null;
  }
}
